<template>
  <div>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="settings"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>

      <transition-group
        name="flip-list"
        tag="div"
        style="
          padding: 30px;
          font-size: 19px;
          display: flex;
          flex-direction: row;
          width: 100%;
          flex-wrap: wrap;
        "
        v-if="part <= parts.length"
      >
        <template
          v-for="index in part"
          :style="{}"
          style="display: inline-block"
        >
          <div
            :key="index + '-' + wordIndex"
            enter-stagger="50"
            leave-stagger="0"
            transition="fade"
            class="dark-inverted"
            :class="'word ' + 'word-' + wordIndex + '-' + index"
            v-for="(word, wordIndex) in parts[index - 1].metin.split(' ')"
            style="display: inline-block; margin-right: 5px; cursor: pointer"
            :style="{
              color: parts[index - 1].skipIndexes.some((x) => x == wordIndex)
                ? 'red !important'
                : parts[index - 1].completedIndexes.some((x) => x == wordIndex)
                ? 'blue !important'
                : parts[index - 1].pendingIndexes.some((k) => k == wordIndex)
                ? 'orange !important'
                : '',
              textDecoration: parts[index - 1].completedIndexes.some(
                (x) => x == wordIndex
              )
                ? 'underline'
                : '',
              opacity:
                parts[index - 1].completedIndexes.length ==
                parts[index - 1].fix.length
                  ? 0.4
                  : 1,
            }"
            @click="check(word, index, wordIndex)"
          >
            {{ word }}
          </div>
        </template>
      </transition-group>
      <div
        v-else
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 47px;
          flex-direction: column;
        "
      >
        <h1 class="dark-inverted">{{ $t("module.level_completed") }}</h1>
        <h1 class="dark-inverted" style="font-size: 50%; margin-top: 10px">
          {{ $t("module.point") }} {{ totalTrue * 5 - totalFalse }}
        </h1>
        <el-button type="primary" round @click="start">{{
          $t("module.continue")
        }}</el-button>
      </div>

      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          v-for="option in options"
          @click="pickOption(option)"
          style="
            display: flex;
            flex: 1;
            background: orange;
            color: white;
            font-size: 22px;
            text-align: center;
            padding: 10px 15px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          "
        >
          {{ option.word }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
export default {
  name: "DuzeltBakalim",
  data() {
    return {
      pause: false,
      ps: [],
      parts: [],
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      part: 1,
      selectedWordIndex: null,
      selectedPart: null,
      options: [],
      totalTrue: 0,
      totalFalse: 0,
      totalClick: 0,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    pickOption(word) {
      this.totalClick += 1;
      if (word.isTrue) {
        this.parts[this.selectedPart].metin = this.parts[
          this.selectedPart
        ].metin.replace(
          this.parts[this.selectedPart].metin.split(" ")[
            this.selectedWordIndex
          ],
          word.word
        );

        this.parts[this.selectedPart].completedIndexes.push(
          this.selectedWordIndex
        );

        this.options = [];

        if (
          this.parts[this.selectedPart].fix.length ==
          this.parts[this.selectedPart].completedIndexes.length
        ) {
          this.part += 1;
        }

        this.selectedWordIndex = null;
        this.selectedPart = null;
        this.lock = false;
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.correct.play();
      } else {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.incorrect.play();
      }
    },
    check(word, index, wordIndex) {
      if (
        this.lock ||
        index != this.part ||
        this.parts[index - 1].skipIndexes.some((k) => k == wordIndex)
      )
        return;
      this.totalClick += 1;
      if (
        this.parts[index - 1].fix.some(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        )
      ) {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.correct.play();
        this.lock = true;
        this.selectedPart = index - 1;
        this.selectedWordIndex = wordIndex;
        this.options = this.parts[index - 1].fix.find(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        ).options;
        this.fixIndex = this.parts[index - 1].fix.findIndex(
          (k) => this.$slugify(k.word) == this.$slugify(word)
        );

        this.parts[this.selectedPart].pendingIndexes.push(
          this.selectedWordIndex
        );

        $(".word").removeClass("animate__animated animate__tada");
        $(".word.word-" + wordIndex + "-" + index).addClass(
          "animate__animated animate__tada"
        );
        this.totalTrue += 1;
      } else {
        if (this.$store.state.selectedTick2 != "sessiz")
          this.$store.state.incorrect.play();
        this.parts[index - 1].skipIndexes.push(wordIndex);
        $(".word").removeClass("animate__animated animate__shakeX");
        $(".word.word-" + wordIndex + "-" + index).addClass(
          "animate__animated animate__shakeX"
        );
        this.totalFalse += 1;
      }
    },
    start() {
      this.part = 1;
      this.totalTrue = 0;
      this.totalFalse = 0;
      this.options = [];
      this.parts = [];
      this.parts = JSON.parse(
        JSON.stringify(this.ps[_.random(0, this.ps.length - 1)])
      );
    },
  },
  created() {
    for (let index = 1; index < 32; index++) {
      this.ps.push(require("./duzeltbakalim/" + index + ".json"));
    }
    this.parts = JSON.parse(
      JSON.stringify(this.ps[_.random(0, this.ps.length - 1)])
    );

    setTimeout(() => {
      this.ps.map((p) => {
        p.map((part) => {
          var parts = part.metin.split(" ");

          part.fix.map((f) => {
            if (
              parts.some((x) => this.$slugify(x) == this.$slugify(f.word)) ===
              false
            ) {
              console.log(f.word);
            }
          });
        });
      });
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/DuzeltBakalim.vue